import { Route, PenLine, Gem, Feather, MessagesSquare, Map } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { WHY_POINTS } from "@/data/content";

const ICONS = { route: Route, pen: PenLine, gem: Gem, feather: Feather, chat: MessagesSquare, map: Map };

export default function WhyMirevaa({ onPlan }) {
  return (
    <section
      id="why-mirevaa"
      data-testid="why-mirevaa-section"
      className="relative overflow-hidden bg-forest py-24 md:py-32"
    >
      <div
        className="pointer-events-none absolute -right-32 -top-32 h-96 w-96 rounded-full border border-gold/15"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -bottom-40 -left-24 h-[28rem] w-[28rem] rounded-full border border-gold/10"
        aria-hidden="true"
      />

      <div className="relative mx-auto max-w-7xl px-6 md:px-10">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <Reveal>
              <Eyebrow light>Why Mirevaa</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 max-w-2xl text-4xl leading-[1.15] text-ivory md:text-5xl">
                Personal by principle, <span className="italic text-gold">not by promise.</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-sm leading-relaxed text-ivory/70">
              Boutique by intention. You will never be just a booking reference. You will be a traveller we know by
              name, travelling exactly the way you should.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-px bg-ivory/10 sm:grid-cols-2 lg:grid-cols-3">
          {WHY_POINTS.map((p, i) => {
            const Icon = ICONS[p.icon];
            return (
              <Reveal key={p.title} y={36} delay={(i % 3) * 0.1}>
                <div
                  data-testid={`why-point-${i + 1}`}
                  className="group flex h-full flex-col bg-forest p-8 transition-colors duration-500 hover:bg-forest-light md:p-10"
                >
                  <Icon className="h-7 w-7 text-gold" strokeWidth={1.25} />
                  <h3 className="mt-6 font-display text-xl text-ivory md:text-2xl">{p.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-ivory/65">{p.copy}</p>
                  <span
                    className="mt-6 h-px w-10 bg-gold/50 transition-all duration-500 group-hover:w-full group-hover:bg-gold"
                    aria-hidden="true"
                  />
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-16 flex flex-col items-center gap-6 text-center">
            <p className="font-display text-2xl italic text-ivory/90 md:text-3xl">
              Every journey begins with a conversation.
            </p>
            <button
              data-testid="why-cta-plan"
              onClick={onPlan}
              className="border border-gold/70 px-10 py-4 text-[11px] uppercase tracking-widest2 font-medium text-gold transition-colors duration-500 hover:bg-gold hover:text-forest"
            >
              Start the Conversation
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
